/**
 * @file   : AInputDate.js
 * @author :  ()
 * @date   : 6/5/2019, 3:04:56 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import { isEmpty, isUndefined } from '../../utilities/GeneralUtils'
import Cont from '../layout/Cont'
import AInputLabel from './AInputLabel'
import ADateText from './date/ADateText'
import ASingleDatePicker from './date/ASingleDatePicker'

export const SELECTOR_TYPE_SIMPLE_CALENDAR = 'simpleCalendar'
export const SELECTOR_TYPE_INLINE = 'inline'

const AInputDate = ({
  cmpRef,
  label,
  placeholder = '',
  formGroup = true,
  style,
  help,
  value,
  selectorType = SELECTOR_TYPE_SIMPLE_CALENDAR,
  onChange,
  minDate = null,
  maxDate = null,
  showClearDate = true,
}) => {
  const getHelpContent = function () {
    let helpContent = null
    if (!isUndefined(help) && !isEmpty(help)) {
      helpContent = <span className={'help-block'}>{help}</span>
    }

    return helpContent
  }

  const getWrapperStyle = function () {
    let divWrapperStyle = ''
    if (!isUndefined(style) && style === 'error') {
      divWrapperStyle = 'has-error'
    }

    return divWrapperStyle
  }

  const getCmpRef = function (isOverlay = false) {
    return cmpRef + (isOverlay ? '-sm-xs' : '-lg-md')
  }

  const getDatePickerWidget = function (isOverlay) {
    return (
      <Cont className={getWrapperStyle()} formGroup={formGroup}>
        <AInputLabel htmlFor={getCmpRef(isOverlay)}>{label}</AInputLabel>
        <ASingleDatePicker
          cmpRef={getCmpRef(isOverlay)}
          placeholder={placeholder}
          showClearDate={showClearDate}
          withFullScreenPortal={isOverlay}
          date={value}
          minDate={minDate}
          maxDate={maxDate}
          onChange={onChange}
        />
        {getHelpContent()}
      </Cont>
    )
  }

  const getDateInput = function () {
    if (selectorType === SELECTOR_TYPE_INLINE) {
      return (
        <Cont>
          <ADateText
            id={cmpRef}
            label={label}
            cmpRef={cmpRef}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={style}
            help={help}
          />
        </Cont>
      )
    }

    return (
      <Cont>
        <Cont hideXS hideSM>
          {getDatePickerWidget(false)}
        </Cont>
        <Cont hideLG hideMD>
          {getDatePickerWidget(true)}
        </Cont>
      </Cont>
    )
  }

  return getDateInput()
}

AInputDate.propTypes = {
  cmpRef: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  formGroup: PropTypes.bool,
  style: PropTypes.string,
  help: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  selectorType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  showClearDate: PropTypes.bool,
}

export default AInputDate
